import { ApplicationProfile } from '@/types/unlock'

export const generateMarriedOptions = (
  applicationProfile: Partial<ApplicationProfile> = {},
  applicationProfiles: ApplicationProfile[] = [],
  nonApplicants: ApplicationProfile[] = []
) => {
  const filteredProfiles = [...applicationProfiles, ...nonApplicants].filter(
    (profile) =>
      profile?.id !== applicationProfile?.id &&
      (profile?.married_to_profile === null ||
        applicationProfile?.married_to_profile === profile.id)
  )

  const options = filteredProfiles.map((profile) => ({
    label: profile?.profile?.full_name,
    value: profile?.id,
  }))

  options.unshift({ label: 'Not Married', value: null })

  return options
}

export const serializeNameDetails = (obj) =>
  JSON.stringify({
    suffix: obj?.suffix,
    last_name: obj?.last_name,
    first_name: obj?.first_name,
    middle_name: obj?.middle_name,
  })

export const formatFullName = (obj) =>
  `${obj.first_name} ${obj.middle_name} ${obj.last_name}${
    obj.suffix ? ', ' + obj.suffix : ''
  }`.trim()

export const formatFullAddress = (mailingAddress) => {
  if (!mailingAddress) return ''

  const { street = '', unit_number = '', city = '', state = '', zip_code = '' } = mailingAddress
  const unitPart = unit_number ? ` Unit ${unit_number},` : ''

  return `${street},${unitPart} ${city}, ${state}, ${zip_code}`.trim()
}
